import React, { useEffect } from 'react';
import Spacer from './Spacer';
import './policy.css';

function DeleteAccount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-container py-5">
      <header>
        <h1 className="text-center mb-4">Delete Your Pool 4 Real Account & Data</h1>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10 col-md-10 col-sm-12">
              <p className="lead">
                Pool 4 Real gives users a way to delete their account and request deletion of associated account data.
                This page is available publicly for users who cannot access the app or already removed the app from their device.
                <Spacer />

                <strong>Delete your account inside the Android app</strong>
                <Spacer />
                Open <strong>Pool 4 Real</strong>, sign in, go to <strong>Settings</strong>, then open <strong>Support & Legal</strong> and select <strong>Delete account & data</strong>.
                The app will ask you to confirm your identity before submitting the deletion request.
                <Spacer />

                <strong>Delete your account inside the iPhone app</strong>
                <Spacer />
                Open <strong>Pool 4 Real</strong>, sign in, go to <strong>My Settings</strong> or account settings, and select the account deletion option.
                <Spacer />

                <strong>Request deletion without using the app</strong>
                <Spacer />
                If you cannot access the app, email us at{' '}
                <a href="mailto:rack@pool4real.com?subject=Pool%204%20Real%20Account%20Deletion%20Request">
                  rack@pool4real.com
                </a>{' '}
                from the email address connected to your Pool 4 Real account.
                <Spacer />

                Please include:
                <Spacer />
                - Your Pool 4 Real account email address
                <br />
                - Your username, display name, or player nickname if available
                <br />
                - A clear statement that you want your Pool 4 Real account and associated data deleted
                <Spacer />

                <strong>Data deleted or anonymized</strong>
                <Spacer />
                When your deletion request is processed, Pool 4 Real deletes or anonymizes account-linked data where reasonably possible, including profile information, authentication account, posts, uploaded profile/post/listing images, messages or inbox records tied to your account, listings, business profiles, map ads, teams, tournaments, favorites, device tokens, and app setup/preferences.
                <Spacer />

                <strong>Data that may be kept temporarily</strong>
                <Spacer />
                Some records may be retained only when necessary for legal compliance, fraud prevention, security, billing, abuse prevention, dispute resolution, tax/accounting obligations, or to protect the integrity of tournaments, teams, business records, moderation, or safety systems. Retained data is limited to what is necessary and kept only for the required period.
                <Spacer />

                <strong>Delete specific data without deleting your account</strong>
                <Spacer />
                You can request deletion of specific data, such as posts, images, profile content, messages, listings, business content, or other user-generated content, without deleting your entire account. Email{' '}
                <a href="mailto:rack@pool4real.com?subject=Pool%204%20Real%20Partial%20Data%20Deletion%20Request">
                  rack@pool4real.com
                </a>{' '}
                and describe the data you want removed.
                <Spacer />

                <strong>Processing and verification</strong>
                <Spacer />
                We may verify account ownership before completing a request. We aim to process valid requests within a reasonable period and will contact you if more information is needed.
                <Spacer />

                <strong>Contact</strong>
                <Spacer />
                For account deletion, data deletion, privacy, or safety questions, contact us at{' '}
                <a href="mailto:rack@pool4real.com">rack@pool4real.com</a>.
              </p>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default DeleteAccount;
